import ControllerBase from 'global/js/ControllerBase';
import { MoleculeFinderSelectStepEvent, MyMoleculeFinderSelectStepEvents } from './m-finder-select-step.events';

interface ComponentRefs {
	backButton: 'backButton';
	backButtonMobile: 'backButtonMobile';
	pdfButton: 'pdfButton';
	productsButton: 'productsButton';
	nextButton: 'nextButton';
}

export default class ControllerFinderSelectStep extends ControllerBase<ComponentRefs> {
	private back: HTMLDivElement;
	private backMobile: HTMLDivElement;
	private products: HTMLDivElement;
	private next: HTMLDivElement;
	private option: number;

	constructor(element: HTMLElement) {
		super(element);
		this.back = this.$references.backButton as HTMLDivElement;
		this.backMobile = this.$references.backButtonMobile as HTMLDivElement;
		this.products = this.$references.productsButton as HTMLDivElement;
		this.next = this.$references.nextButton as HTMLDivElement;

		this.init();
	}

	private init(): void {
		const options = this.$element.querySelectorAll<HTMLDivElement>('.js-option');

		// Creates an event when back button (desktop) has been clicked
		this.back &&
			this.back.addEventListener('click', (e) => {
				e.preventDefault();
				this.dispatchCustomEvent(MyMoleculeFinderSelectStepEvents.back, {}, true, true);
			});

		// Creates an event when back button (mobile) has been clicked
		this.backMobile &&
			this.backMobile.addEventListener('click', (e) => {
				e.preventDefault();
				this.dispatchCustomEvent(MyMoleculeFinderSelectStepEvents.back, {}, true, true);
			});

		// Creates an event when show results has been clicked
		this.products.addEventListener('click', (e) => {
			e.preventDefault();

			this.dispatchCustomEvent(MyMoleculeFinderSelectStepEvents.products, {}, true, true);
		});

		// If we are in mobile
		if (this.isMobile()) {
			// Creates an event when next button has been clicked
			this.next &&
				this.next.addEventListener('click', (e: MouseEvent | PointerEvent) => {
					e.preventDefault();

					if (this.next.dataset.step === 'last-question') {
						this.dispatchCustomEvent(MyMoleculeFinderSelectStepEvents.start, {}, true, true);
					} else {
						this.dispatchCustomEvent(
							MyMoleculeFinderSelectStepEvents.clicked,
							{
								additionalId: this.option,
							},
							true,
							true,
						);
					}
				});
		}

		options &&
			options.forEach((option: HTMLDivElement) => {
				option.addEventListener('click', (event) => this.emitEvent(event, option));
			});
	}

	/**
	 * Gets the option value and fires an event
	 * @param event
	 * @param target
	 */
	private emitEvent(event: MouseEvent | PointerEvent, target: HTMLDivElement): void {
		event.preventDefault();

		this.option = Number(target.dataset.searchId);

		if (this.isMobile()) {
			target.classList.toggle('selected');
			target.querySelector('.a-button')?.classList.toggle('selected');
		} else {
			this.dispatchCustomEvent<MoleculeFinderSelectStepEvent>(
				MyMoleculeFinderSelectStepEvents.clicked,
				{
					additionalId: this.option,
				},
				true,
				true,
			);
		}
	}

	// Checks if we are in mobile
	private isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}
}
